import React from 'react';
import { InputNumber, InputNumberProps } from 'antd';

import './index.less';

import { MAIN_CLASS_NAME } from './const';

const IbNumberInput: React.FC<InputNumberProps> = ({ className, ...otherProps }) => {
  const classes = [MAIN_CLASS_NAME];
  className && classes.push(className);
  return <InputNumber className={classes.join(' ')} {...otherProps} />;
};

export default IbNumberInput;
